import { render, staticRenderFns } from "./FlightPrice.vue?vue&type=template&id=7c01fdea&scoped=true"
import script from "./FlightPrice.vue?vue&type=script&lang=js"
export * from "./FlightPrice.vue?vue&type=script&lang=js"
import style0 from "./FlightPrice.vue?vue&type=style&index=0&id=7c01fdea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c01fdea",
  null
  
)

export default component.exports